import Layout from 'base/layouts/Layout';

import { CART_ITEM, CART_BASE } from 'cart/constants/paths';
import EditCartItemModal from 'cart/containers/EditCartItemModal';
import CartDrawer from 'cart/containers/CartDrawer';

const routes = [
  {
    path: CART_BASE,
    exact: true,
    Component: CartDrawer,
    Layout
  },
  {
    path: CART_ITEM,
    exact: true,
    Component: EditCartItemModal,
    Layout
  }
];

export default routes;
